import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'spray-can-banner',
    templateUrl: './spray-can.component.html',
    styleUrls: ['./spray-can.component.css'],
    standalone: false
})
export class SprayCanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
